import { QueryKeys } from "@/constants";
import { fetchSurveyQuestions, submitSurveyFeedback } from "@/services/survey";
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery, useMutation } from "@tanstack/react-query";
import useUserInfo from "./use-user-info";
import type {
  IFetchSurveyQuestionsPayload,
  ISubmitSurveyFeedbackPayload,
  ISurveyQuestionnaire,
} from "@/model/survey";

export const useFetchSurveyQuestionnaire = (
  outgoingTrackId: string,
  templateId: string,
): UseQueryResult<ISurveyQuestionnaire, Error> => {
  const userInfo = useUserInfo();
  const fetchQuestionPayload: IFetchSurveyQuestionsPayload = {
    groupId: userInfo?.groupId,
    memberId: userInfo?.memberId,
    username: userInfo?.username,
    token: userInfo?.accessToken,
    outgoingTrackId,
    templateId,
  };
  return useQuery<ISurveyQuestionnaire>({
    queryKey: [QueryKeys.FETCH_SURVEY_QUESTIONNAIRE, outgoingTrackId],
    queryFn: async (): Promise<ISurveyQuestionnaire> => {
      const response = await fetchSurveyQuestions(fetchQuestionPayload);
      return response ?? [];
    },
    enabled:
      Boolean(userInfo.username) &&
      Boolean(outgoingTrackId) &&
      Boolean(templateId) &&
      Boolean(userInfo.accessToken),
    retry: false,
  });
};

export const useSubmitSurveyFeedback = () => {
  const userInfo = useUserInfo();

  return useMutation({
    mutationKey: [QueryKeys.SUBMIT_SURVEY_FEEDBACK],
    mutationFn: (surveyFeedback: unknown) => {
      if (!userInfo) {
        throw new Error("User info is not available");
      }

      const submitSurveyFeedbackPayload: ISubmitSurveyFeedbackPayload = {
        groupId: userInfo?.groupId,
        memberId: userInfo?.memberId,
        username: userInfo?.username,
        token: userInfo?.accessToken,
        data: surveyFeedback as [unknown],
      };
      // console.log("survey feedback payload >", submitSurveyFeedbackPayload);
      const response = submitSurveyFeedback(submitSurveyFeedbackPayload);

      // const response = {
      //   summary: {
      //     status_message: "success",
      //     member_id: "11934d2b86f8dbb1e8e4a584afdbd884z5db",
      //     status_code: "REQ-200",
      //     query_id: "HRA-002",
      //     group_id: "Z5DEMO_B",
      //     query: "",
      //     query_time: 50,
      //   },
      //   data: {
      //     success: true,
      //     message: "Thanks for filling out the survey",
      //   },
      // };

      return response;
    },
  });
};
